// pro_video_slider
$(document).ready(function () {

  var $vid_slider = $(".video_slider_item_wrap");

  // ADD CUSTOM ARROW WRAPPER
  $vid_slider.on("init", function (event, slick) {
    var wrapper = $('<div class="slik_arrow_wrapper"></div>');
    wrapper.append(slick.$prevArrow);
    wrapper.append(slick.$nextArrow);
    $(this).append(wrapper);
  });

  // INITIALIZE SLIDER
  $vid_slider.slick({
    dots: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: "260px",
    centerMode: true,
    infinite: true,
    arrows: true,
    speed: 2000,

    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 3, centerPadding: "180px" }},
      { breakpoint: 1200, settings: { slidesToShow: 2, centerPadding: "120px" }},
      { breakpoint: 992,  settings: { slidesToShow: 2, centerPadding: "80px" }},
      { breakpoint: 768,  settings: { slidesToShow: 1, centerPadding: "60px" }},
      { breakpoint: 575,  settings: { slidesToShow: 1, centerPadding: "30px" }}
    ]
  });

  // AUTOPLAY ACTIVE VIDEO ONLY
  $vid_slider.on("afterChange", function (event, slick, currentSlide) {
    $("video").each(function () { this.pause(); });

    let activeVideo = $(slick.$slides[currentSlide]).find("video")[0];
    if (activeVideo) {
      activeVideo.muted = true;
      activeVideo.play();
    }
  });

  // PLAY FIRST VIDEO ON LOAD
  setTimeout(function () {
    let firstVideo = $(".video_slider_item_wrap .slick-slide.slick-current video")[0];
    if (firstVideo) {
      firstVideo.muted = true;
      firstVideo.play();
    }
  }, 300);

});



// Animated Offcanvas----------------------
document.addEventListener("DOMContentLoaded", function () {
  const navItems = document.querySelectorAll(
    ".navlist .navitem, .contct-btn .contact-us"
  );
  const offcanvasBtn = document.querySelector(".nvbr-tglr");
  const offcanvasElement = document.querySelector("#offcanvasNavbar");

  function startSlideInAnimation() {
    navItems.forEach((item, index) => {
      item.style.animation = "none";
      item.offsetHeight;
      item.style.animation = `slideIn 0.7s forwards ${index * 0.4}s`;
      item.classList.add("in");
    });
  }

  offcanvasBtn.addEventListener("click", function () {
    startSlideInAnimation();
  });

  offcanvasElement.addEventListener("hidden.bs.offcanvas", function () {
    navItems.forEach((item) => {
      item.classList.remove("in");
      item.style.animation = "none";
    });
  });
});

// Animated Offcanvas----------------------


// ====================caseStudy_slider

// ====================caseStudy_slider

var $slider = jQuery(".client_say_slider_wrap");

$slider.on("init", function (event, slick) {
    var wrapper = $('<div class="slik_arrow_wrapper"></div>');
    wrapper.append(slick.$prevArrow);
    wrapper.append(slick.$nextArrow);
    $(this).append(wrapper);
  });

if ($slider.length) {
  $slider.slick({
    dots: false,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true,
    fade: false,
    cssEase: "linear",

    responsive: [
      {
        breakpoint: 1600,
        settings: { slidesToShow: 3, centerMode: true }
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 2, centerMode: false }
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 2, centerMode: false }
      },
      {
        breakpoint: 768,

        settings: { slidesToShow: 1, centerMode: true, centerPadding: "30px", autoplay: false }
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1, centerMode: true, centerPadding: "30px", autoplay: false }
      }
    ]
  });

  // ---------- PROGRESS BAR FUNCTION ----------
  function progress(sliders) {
    sliders.each(function () {
      var slider = jQuery(this);

      // Progress element inside same section container
      var $progressBarFill = slider
        .closest("section, .container, .client_say_slider_area")
        .find(".progress .progress-fill");

      // Set initial width
      var initial = (1 / slider.slick("getSlick").slideCount) * 100;
      $progressBarFill.css("width", initial + "%");

      // Update width on slide change
      slider.on("afterChange", function (event, slick, currentSlide) {
        var calc = ((currentSlide + 1) / slick.slideCount) * 100;
        $progressBarFill.css("width", calc + "%");
      });
    });
  }

  progress($slider);
}

// Create arrow wrapper for Slick
$('.home_studio_slider').on('init', function (event, slick) {
  var wrapper = $('<div class="img_compari_arrow_wrapper"></div>');
  wrapper.append(slick.$prevArrow);
  wrapper.append(slick.$nextArrow);
  $(this).append(wrapper);
});

var $slider = jQuery(".home_studio_slider");

if ($slider.length) {
  $slider.slick({
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    centerMode: false,
    variableWidth: true,
    arrows: true,
    autoplay: false,

    responsive: [
      {
        breakpoint: 1600,
        settings: { slidesToShow: 2, variableWidth: true }
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 2, variableWidth: false }
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 2, variableWidth: false }
      },
      {
        breakpoint: 768,
        autoplay: false,
        settings: { slidesToShow: 1, variableWidth: false }
      },
      {
        breakpoint: 576,
        autoplay: false,
        settings: { slidesToShow: 1, variableWidth: false }

      }
    ]
  });

  // ---- PROGRESS BAR ----
  function progress(slider) {
    var slick = slider.slick("getSlick");
    var slideCount = slick.slideCount;

    var $progressFill = slider
      .closest(".container")
      .find(".progress .progress-fill");

    // Set initial progress
    var initialWidth = (1 / slideCount) * 100;
    $progressFill.css("width", initialWidth + "%");

    // On slide change
    slider.on("afterChange", function (event, slick, currentSlide) {
      var width = ((currentSlide + 1) / slick.slideCount) * 100;
      $progressFill.css("width", width + "%");
    });
  }

  progress($slider); // run progress bar
}


// start scroll effects..........
(function () {
  const items = Array.from(document.querySelectorAll('.feature-item'));
  const segment = document.getElementById('progressSegment');
  const wrap = document.getElementById('progressWrap');

  function centerY(el) {
    const r = el.getBoundingClientRect();
    return r.top + r.height / 2;
  }

  function dotCenterInWrap(item) {
    const dotOffset = 6;
    const dotSize = 14;
    const itemRect = item.getBoundingClientRect();
    const wrapRect = wrap.getBoundingClientRect();
    const dotCenterViewportY = itemRect.top + dotOffset + dotSize / 2;
    return dotCenterViewportY - wrapRect.top;
  }

  function findActiveIndex() {
    const viewportCenter = window.innerHeight * 0.4;
    let idx = 0;
    let min = Infinity;

    items.forEach((el, i) => {
      const cy = centerY(el);
      const d = Math.abs(cy - viewportCenter);
      if (d < min) { min = d; idx = i; }
    });

    return idx;
  }

  function update() {
    const activeIndex = findActiveIndex();

    items.forEach((it, i) => {
      it.classList.toggle("active", i === activeIndex);
    });

    const active = items[activeIndex];
    const para = active.querySelector('.feature-itemRightiteam');
    const topY = dotCenterInWrap(active) - 13;

    const paraHeight = para.getBoundingClientRect().height;

    segment.style.top = topY + "px";
    segment.style.height = paraHeight + "px";
  }

  let tick = false;
  function onScroll() {
    if (!tick) {
      requestAnimationFrame(() => {
        update();
        tick = false;
      });
      tick = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  setTimeout(update, 150);
})();

// start popup....................
document.addEventListener("DOMContentLoaded", () => {
  const points = document.querySelectorAll(".point");

  points.forEach(point => {
    point.addEventListener("click", (e) => {
      e.stopPropagation();

      points.forEach(p => {
        if (p !== point) p.classList.remove("active");
      });

      point.classList.toggle("active");
    });
  });

  document.addEventListener("click", () => {
    points.forEach(p => p.classList.remove("active"));
  });
});


// start for video bannear.............................
(function () {
  const video = document.getElementById('heroVideo');
  const btn = document.getElementById('playToggle');
  const icon = document.getElementById('playerIcon');

  // Accessible states:
  function setPlayingUI(isPlaying) {
    if (isPlaying) {
      btn.classList.remove('player--paused');
      btn.classList.add('player--playing');
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Pause video');
      // show pause icon: two vertical bars
      icon.innerHTML = '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"></path>';
    } else {
      btn.classList.add('player--paused');
      btn.classList.remove('player--playing');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Play video');
      // show play icon
      icon.innerHTML = '<path d="M8 5v14l11-7z"></path>';
    }
  }

  // Attempt to autoplay (muted) — many browsers allow muted autoplay
  function tryAutoplay() {
    if (!video) return;
    video.muted = true;
    video.loop = true;
    // If the video has a src it may autoplay; we check play promise
    if (video.querySelector('source')) {
      const p = video.play();
      if (p !== undefined) {
        p.then(() => {
          setPlayingUI(true);
        }).catch(() => {
          setPlayingUI(false);
        });
      }
    } else {
      // no source: keep poster shown; set paused UI
      setPlayingUI(false);
    }
  }

  // Toggle play/pause when user clicks
  btn.addEventListener('click', function (e) {
    if (!video || !video.querySelector('source')) {
      // no video source — do a small pulse effect but keep poster
      setPlayingUI(false);
      btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.05)' }, { transform: 'scale(1)' }], { duration: 240 });
      return;
    }

    if (video.paused) {
      video.play().catch(() => {/* ignore */ });
      setPlayingUI(true);
    } else {
      video.pause();
      setPlayingUI(false);
    }
  });

  // sync UI if user uses other controls or autoplay state changes
  video.addEventListener('play', () => setPlayingUI(true));
  video.addEventListener('pause', () => setPlayingUI(false));
  video.addEventListener('ended', () => setPlayingUI(false));

  // run autoplay attempt
  tryAutoplay();
})();

// end for video bannear.............................

// start trackingsection-item........................
const items = document.querySelectorAll(".trackingsection-item");

items.forEach(item => {
  item.addEventListener("click", () => {

    // Close other items
    items.forEach(el => {
      if (el !== item) {
        el.classList.remove("active");
      }
    });

    // Toggle clicked one
    item.classList.toggle("active");
  });
});
// end trackingsection-item..........................

// start comparison_slider...........................
// Create arrow wrapper for Slick
$('.img_compari_slider').on('init', function (event, slick) {
  var wrapper = $('<div class="img_compari_arrow_wrapper"></div>');
  wrapper.append(slick.$prevArrow);
  wrapper.append(slick.$nextArrow);
  $(this).append(wrapper);
});

// Slick Slider Init (Swipe Disabled Fully)
$('.img_compari_slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1200,
  slidesToShow: 1,
  centerMode: true,
  variableWidth: true,
  draggable: false,     // DISABLE MOUSE DRAG
  swipe: false,         // DISABLE SWIPE
  touchMove: false,     // DISABLE TOUCH MOVE
  focusOnSelect: false
});

// Comparison Slider (Handle drag ALWAYS works on mobile)
function initComparisonSlider(box) {
  const afterWrap = box.querySelector('.after-wrapper');
  const handle = box.querySelector('.handle');
  let dragging = false;

  function updatePosition(x) {
    const rect = box.getBoundingClientRect();
    let pct = ((x - rect.left) / rect.width) * 100;
    pct = Math.min(100, Math.max(0, pct));
    afterWrap.style.width = pct + '%';
    handle.style.left = pct + '%';
  }

  // Desktop mouse drag
  handle.addEventListener('mousedown', () => dragging = true);
  window.addEventListener('mouseup', () => dragging = false);
  window.addEventListener('mousemove', (e) => {
    if (dragging) updatePosition(e.clientX);
  });

  // ✔ MOBILE TOUCH DRAG IS ALWAYS ENABLED HERE
  handle.addEventListener('touchstart', () => dragging = true);
  window.addEventListener('touchend', () => dragging = false);
  window.addEventListener('touchmove', (e) => {
    if (dragging) updatePosition(e.touches[0].clientX);
  }, { passive: false });
}

// Init comparison sliders
document.querySelectorAll('.compari_slider').forEach(initComparisonSlider);


// end comparison_slider...........................

// $(document).ready(function () {
//   var $slider = jQuery(".b2b_home_studio .home_studio_slider");
//   var $progressBar = $(".progress_bar");
//   var $progressBarLabel = $(".slider__label");

  
//   $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
//     var calc = (nextSlide / (slick.slideCount - 1)) * 100;

//     $progressBar
//       .css("background-size", calc + "% 100%")
//       .attr("aria-valuenow", calc);

//     $progressBarLabel.text(calc + "% completed");
//   });

//   if ($slider.length) {
//     $slider.slick({
//       dots: false,
//       infinite: false,
//       speed: 1200,
//       slidesToShow: 2,
//       centerMode: false,
//       variableWidth: true,
//       arrows: false,
//       autoplay: true,

//       responsive: [
//         {
//           breakpoint: 1600,
//           settings: { slidesToShow: 2, variableWidth: true }
//         },
//         {
//           breakpoint: 1200,
//           settings: { slidesToShow: 2, variableWidth: false }
//         },
//         {
//           breakpoint: 992,
//           settings: { slidesToShow: 2, variableWidth: false }
//         },
//         {
//           breakpoint: 768,
//           autoplay: false,
//           settings: { slidesToShow: 1, variableWidth: false }
//         },
//         {
//           breakpoint: 576,
//           autoplay: false,
//           settings: { slidesToShow: 1, variableWidth: false }

//         }
//       ]
//     });

//   }


// });

// start step_slider................
var $slider = $('.step_slider');

$slider.on("init", function (event, slick) {
    var wrapper = $('<div class="slik_arrow_wrapper"></div>');
    wrapper.append(slick.$prevArrow);
    wrapper.append(slick.$nextArrow);
    $(this).append(wrapper);
});

$slider.slick({
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 3,
    infinite: true,
    arrows: true,  // arrows enabled (required)
    speed: 900,
    autoplay: false,
    autoplaySpeed: 2200,

    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                centerMode: true,
                centerPadding: '0px'
            }
        },
        {
            breakpoint: 768,
            settings: {
                centerMode: false,
                slidesToShow: 1,
                centerPadding: '0px',
                speed: 1000
            }
        },
        {
            breakpoint: 576,
            settings: {
                centerMode: false,
                slidesToShow: 1,
                centerPadding: '0px',
                speed: 1000
            }
        }
    ]
});


// fitness_slider
// $(document).ready(function () {
//   var $slider = jQuery(".home_studio_slider.fitness_slider");


//   // var $vid_slider = $(".video_slider_item_wrap");
//   var $progressBar = $(".progress_bar");
//   var $progressBarLabel = $(".slider__label");

//   // Initialize progress bar
//   $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
//     var calc = (nextSlide / (slick.slideCount - 1)) * 300;

//     $progressBar
//       .css("background-size", calc + "% 100%")
//       .attr("aria-valuenow", calc);

//     $progressBarLabel.text(calc + "% completed");
//   });

//   if ($slider.length) {
//     $slider.slick({
//       dots: true,
//       infinite: true,
//       speed: 1200,
//       slidesToShow: 2,
//       centerMode: false,
//       variableWidth: true,
//       arrows: true,
//       autoplay: false,

//       responsive: [
//         {
//           breakpoint: 1600,
//           settings: { slidesToShow: 2, variableWidth: true, arrows: true, }
//         },
//         {
//           breakpoint: 1200,
//           settings: { slidesToShow: 2, variableWidth: false, arrows: true, }
//         },
//         {
//           breakpoint: 992,
//           settings: { slidesToShow: 2, variableWidth: false, arrows: true, }
//         },
//         {
//           breakpoint: 768,
//           autoplay: false,
//           settings: { slidesToShow: 1, variableWidth: false, arrows: true, }
//         },
//         {
//           breakpoint: 576,
//           autoplay: false,
//           settings: { slidesToShow: 1, variableWidth: false, arrows: true, }

//         }
//       ]
//     });

//   }


// });